import GameInfo from '@/components/features/casino/game-info';
import { useTranslation } from 'next-i18next';
import step1Img from '/public/assets/images/casino/dice-game/dice-work-step-1.png';
import step2Img from '/public/assets/images/casino/dice-game/dice-work-step-2.png';
import step3Img from '/public/assets/images/casino/dice-game/dice-work-step-3.png';
import step4Img from '/public/assets/images/casino/dice-game/dice-work-step-4.png';
import HowItWorks from '@/components/ui/HowItWorks';

export default function DiceGameInfo() {
  const { t } = useTranslation();
  const howItWorksSteps = [
    {
      text: t(`Specify your bet value.`),
      imageSrc: step1Img.src,
    },
    {
      text: t(`You set the value you want predict to be over or under
 using the slider`),
      imageSrc: step2Img.src,
    },
    {
      text: t(`If the dice value rolled is 
not according to your
prediction, your initial
bet will be lost.`),
      imageSrc: step3Img.src,
    },
    {
      text: t(
        `If the dice value rolled is according to your prediction, you win and receive a payout based on the odds and the amount you bet`,
      ),
      imageSrc: step4Img.src,
    },
  ];

  return (
    <GameInfo title={t('Dice')} gameId={'1004'}>
      <HowItWorks steps={howItWorksSteps}></HowItWorks>
    </GameInfo>
  );
}
